import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { IBookResponse, IFundTransferResponse, IFundTransferRequest } from '@lib/interfaces/transfer.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TransferService {
    environment_url: string;
    constructor(private http: HttpClient) {
        this.environment_url = environment.api_url;
    }

    public fundTransfer(payload: IFundTransferRequest): Observable<IFundTransferResponse> {
        return this.http.post<IFundTransferResponse>(`${this.environment_url}nfront/v1/proxy/accounts/transfer`, payload, {
            headers: new HttpHeaders({
                'x-nymos-idempotency-key': crypto.randomUUID(),
            }),
        });
    }

    public bookFxRate(id: string): Observable<IBookResponse> {
        return this.http.put<IBookResponse>(
            `${this.environment_url}nfront/v1/proxy/fxrates/${id}:book`,
            {},
            {
                headers: new HttpHeaders({
                    'x-nymos-idempotency-key': crypto.randomUUID(),
                }),
            },
        );
    }
}
